import { ca } from '@cian/analytics';

export const trackPhoneOpen = (label: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action: 'Open_card_gallery',
    label,
    useLastProducts: true,
  });
};
